import { render, staticRenderFns } from "./FluxoCaixaRelatorioAnterior.vue?vue&type=template&id=3f587d54&scoped=true&"
import script from "./FluxoCaixaRelatorioAnterior.vue?vue&type=script&lang=js&"
export * from "./FluxoCaixaRelatorioAnterior.vue?vue&type=script&lang=js&"
import style0 from "./FluxoCaixaRelatorioAnterior.vue?vue&type=style&index=0&id=3f587d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f587d54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow})
